import React from "react";
import { FormattedMessage } from "react-intl";
import AddressInput, {IAddressInputProps} from "./AddressInput";

export interface IAddress2InputProps extends IAddressInputProps {}

export default (props: IAddress2InputProps) => {
  const { label = <FormattedMessage id="contacts.address2" /> } = props;

  return <AddressInput {...props} label={label} isRequired={false} />;
};
